import { useSelector } from 'react-redux';
import { ReduxState } from '../types';
import { UserRole, UserType } from '../constants/user_types';

/**
 * Mirrors the backend `isAuthorizedForAdminOperations` guard: irrigation writes (start/stop/
 * activate/delete) are limited to CDTEC users with an ADMIN or AGRO role. Read-only users still
 * see irrigation states; they just don't get the action controls.
 */
const useCanControlIrrigation = (): boolean => {
  const user = useSelector((state: ReduxState) => state.account.user);
  if (!user || user.type !== UserType.CDTEC) return false;
  return user.role === UserRole.ADMIN || user.role === UserRole.AGRO;
};

export default useCanControlIrrigation;
